export const ClassNames = (names = []) =>
  names
    .filter((n) => n)
    .join(' ')
    .trim()
